import type { Maybe } from "~/types";

interface BooleanProps {
  value: Maybe<boolean>;
}

export function Boolean({ value }: BooleanProps) {
  return value == null ? "-" : value ? "True" : "False";
}
